// Static UI translations. Dynamic content (services, hero text, etc.)
// is fetched from the backend in both IT and EN.

const translations = {
  it: {
    nav: {
      home: "Home",
      services: "Servizi",
      about: "Chi Siamo",
      gallery: "Galleria",
      contact: "Contatti",
      manifesto: "Manifesti",
      admin: "Admin",
    },
    common: {
      h24: "H24",
      available_24_7: "Disponibili 24/7",
      learn_more: "Scopri di più",
      call_now: "Chiama ora",
      write_us: "Scrivici",
      open_in_maps: "Apri su Mappe",
      whatsapp_chat: "Chatta su WhatsApp",
      language: "Lingua",
    },
    sections: {
      services_label: "I nostri servizi",
      services_subtitle: "Assistenza completa, sempre al vostro fianco",
      about_label: "Chi siamo",
      about_subtitle: "Etica, professionalità e dedizione",
      consorzio_label: "Il Consorzio",
      stats_agencies: "Agenzie associate",
      stats_employees: "Dipendenti",
      stats_h24: "Reperibilità",
      gallery_label: "Galleria",
      gallery_subtitle: "Mezzi e personale a vostra disposizione",
      contact_label: "Contatti",
      contact_subtitle: "Siamo qui per voi, in ogni momento",
      offices: "Sedi",
      phones: "Telefoni",
      email: "Email",
    },
    footer: {
      tagline: "Onoranze Funebri Barone — Melendugno · Borgagne",
      rights: "Tutti i diritti riservati",
    },
    admin: {
      login_title: "Accesso Riservato",
      login_subtitle: "Pannello di amministrazione",
      username: "Nome utente",
      password: "Password",
      sign_in: "Accedi",
      logout: "Esci",
      dashboard: "Pannello",
      tab_general: "Generale",
      tab_about: "Chi Siamo",
      tab_contact: "Contatti",
      tab_whatsapp: "WhatsApp",
      tab_services: "Servizi",
      tab_gallery: "Galleria",
      tab_manifesto: "Manifesti",
      tab_seo: "SEO",
      tab_booking: "Prenotazione",
      tab_tech: "Tecnico / IT",
      save: "Salva",
      saved: "Modifiche salvate",
      add: "Aggiungi",
      edit: "Modifica",
      delete: "Elimina",
      cancel: "Annulla",
      confirm_delete: "Sei sicuro di voler eliminare?",
      title_it: "Titolo (Italiano)",
      title_en: "Titolo (Inglese)",
      desc_it: "Descrizione (Italiano)",
      desc_en: "Descrizione (Inglese)",
      caption_it: "Didascalia (Italiano)",
      caption_en: "Didascalia (Inglese)",
      icon: "Icona (lucide-react)",
      order: "Ordine",
      image_url: "URL Immagine",
      back_to_site: "Torna al sito",
      invalid_credentials: "Credenziali non valide",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      gallery: "Gallery",
      contact: "Contact",
      manifesto: "Notices",
      admin: "Admin",
    },
    common: {
      h24: "24/7",
      available_24_7: "Available 24/7",
      learn_more: "Learn more",
      call_now: "Call now",
      write_us: "Write to us",
      open_in_maps: "Open in Maps",
      whatsapp_chat: "Chat on WhatsApp",
      language: "Language",
    },
    sections: {
      services_label: "Our services",
      services_subtitle: "Complete care, always by your side",
      about_label: "About us",
      about_subtitle: "Ethics, professionalism and dedication",
      consorzio_label: "The Consortium",
      stats_agencies: "Associated agencies",
      stats_employees: "Employees",
      stats_h24: "Availability",
      gallery_label: "Gallery",
      gallery_subtitle: "Vehicles and personnel at your service",
      contact_label: "Contact",
      contact_subtitle: "We are here for you, at any time",
      offices: "Offices",
      phones: "Phones",
      email: "Email",
    },
    footer: {
      tagline: "Barone Funeral Honours — Melendugno · Borgagne",
      rights: "All rights reserved",
    },
    admin: {
      login_title: "Restricted Access",
      login_subtitle: "Administration panel",
      username: "Username",
      password: "Password",
      sign_in: "Sign in",
      logout: "Log out",
      dashboard: "Dashboard",
      tab_general: "General",
      tab_about: "About",
      tab_contact: "Contact",
      tab_whatsapp: "WhatsApp",
      tab_services: "Services",
      tab_gallery: "Gallery",
      tab_manifesto: "Notices",
      tab_seo: "SEO",
      tab_booking: "Booking",
      tab_tech: "Tech / IT",
      save: "Save",
      saved: "Changes saved",
      add: "Add",
      edit: "Edit",
      delete: "Delete",
      cancel: "Cancel",
      confirm_delete: "Are you sure you want to delete?",
      title_it: "Title (Italian)",
      title_en: "Title (English)",
      desc_it: "Description (Italian)",
      desc_en: "Description (English)",
      caption_it: "Caption (Italian)",
      caption_en: "Caption (English)",
      icon: "Icon (lucide-react)",
      order: "Order",
      image_url: "Image URL",
      back_to_site: "Back to site",
      invalid_credentials: "Invalid credentials",
    },
  },
};

export default translations;
